import { useState, useEffect } from "react";
import { client } from "../../sanityClient";
import NepaliDatePicker from '@zener/nepali-datepicker-react';
import '@zener/nepali-datepicker-react/index.css';
import "./EditGrainForm.css";

export default function EditGrainForm({ transaction, onClose, onUpdate }) {
    const [form, setForm] = useState({
        buyOrSell: transaction.buyOrSell,
        quantity: transaction.quantity,
        rate: transaction.rate,
        finalPrice: transaction.finalPrice,
        time: transaction.time.split("T")[0],
        remarks: transaction.remarks || "",
        GTrID: transaction.GTrID,
        grainId: transaction.grain?._id || ""
    });
    const [grains, setGrains] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        client.fetch(`*[_type == "grain"]{_id, grainName}`).then(setGrains);
    }, []);

    // AUTO CALCULATE RATE
    useEffect(() => {
        const qty = +form.quantity || 0;
        const finalPrice = +form.finalPrice || 0;
        if (qty > 0 && finalPrice > 0) {
            setForm(prev => ({ ...prev, rate: (finalPrice / qty).toFixed(2) }));
        } else {
            setForm(prev => ({ ...prev, rate: "" }));
        }
    }, [form.quantity, form.finalPrice]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await client
                .patch(transaction._id)
                .set({
                    buyOrSell: form.buyOrSell,
                    quantity: +form.quantity,
                    rate: +form.rate,
                    finalPrice: +form.finalPrice,
                    time: new Date(form.time).toISOString(),
                    remarks: form.remarks,
                    grain: { _type: "reference", _ref: form.grainId }
                })
                .commit();

            onUpdate();
            onClose();
        } catch (err) {
            console.error(err);
            alert("Failed to update grain");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="edit-grain-modal" onClick={onClose}>
            <div className="edit-grain-content-wide" onClick={(e) => e.stopPropagation()}>
                <div className="edit-grain-header">
                    <h5 className="edit-grain-title">Edit Grain Transaction</h5>
                    <button className="edit-grain-close" onClick={onClose}>×</button>
                </div>
                <div className="edit-grain-body">
                    <form onSubmit={handleSubmit}>
                        <div className="edit-grain-group">
                            <label className="edit-grain-label">Transaction ID</label>
                            <input type="text" className="edit-grain-input" value={form.GTrID} disabled style={{ backgroundColor: "#f1f5f9", color: "#475569" }} />
                        </div>

                        <div className="row g-2">
                            <div className="col-md-6">
                                <label className="edit-grain-label">Grain</label>
                                <select className="edit-grain-input" value={form.grainId} onChange={handleChange} name="grainId" required disabled={loading}>
                                    <option value="">Select Grain</option>
                                    {grains.map(g => (
                                        <option key={g._id} value={g._id}>{g.grainName}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-md-6">
                                <label className="edit-grain-label">Type</label>
                                <select className="edit-grain-input" value={form.buyOrSell} onChange={handleChange} name="buyOrSell" disabled={loading}>
                                    <option value="Buy">Buy</option>
                                    <option value="Sell">Sell</option>
                                </select>
                            </div>
                        </div>

                        <div className="row g-2 mt-1">
                            <div className="col-md-6">
                                <label className="edit-grain-label">Quantity (kg)</label>
                                <input type="number" className="edit-grain-input" value={form.quantity} onChange={handleChange} name="quantity" required disabled={loading} />
                            </div>
                            <div className="col-md-6">
                                <label className="edit-grain-label">Rate (₹/kg)</label>
                                <input type="number" className="edit-grain-input" value={form.rate} readOnly style={{ backgroundColor: "#f1f5f9", color: "#065f46", fontWeight: "700" }} />
                            </div>
                        </div>

                        <div className="row g-2 mt-1">
                            <div className="col-md-6">
                                <label className="edit-grain-label">Final Price (₹)</label>
                                <input type="number" className="edit-grain-input" value={form.finalPrice} onChange={handleChange} name="finalPrice" required disabled={loading} />
                            </div>
                        </div>

                        <div className="edit-grain-group mt-2">
                            <label className="edit-grain-label">Date</label>
                            <NepaliDatePicker
                                value={form.time ? new Date(form.time) : null}
                                onChange={(date) => {
                                    if (date) {
                                        const regularDate = date.toADasDate ? date.toADasDate() : date;
                                        const year = regularDate.getFullYear();
                                        const month = String(regularDate.getMonth() + 1).padStart(2, '0');
                                        const day = String(regularDate.getDate()).padStart(2, '0');
                                        const localDateString = `${year}-${month}-${day}`;
                                        setForm(prev => ({ ...prev, time: localDateString }));
                                    } else {
                                        setForm(prev => ({ ...prev, time: null }));
                                    }
                                }}
                                placeholder="Select BS Date"
                                className="edit-grain-input"
                                disabled={loading}
                                type="BS"
                            />
                        </div>

                        <div className="edit-grain-group">
                            <label className="edit-grain-label">Remarks</label>
                            <textarea className="edit-grain-input edit-grain-textarea" rows="2" value={form.remarks} onChange={handleChange} name="remarks" disabled={loading} />
                        </div>

                        <button type="submit" className="edit-grain-btn" disabled={loading}>
                            {loading ? "Updating..." : "Update Transaction"}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}